import { useContext, useEffect, useState } from 'react'
import { Box, Card, Grid, Toolbar, IconButton, Button } from '@mui/material'
import { ArrowBackIos } from '@mui/icons-material'
import { useNavigate } from 'react-router-dom'
import { AuthContext, useSignature } from '../../context'
import { UserDataEditDialog } from '../../dialogs'

const UserProfilePage = () => {
    const { userData, refreshSessionToken } = useContext(AuthContext)
    const { setOpenSign } = useSignature()
    const [openUserDataEdit, setOpenUserDataEdit] = useState(false)
    const [refreshing, setRefreshing] = useState(false)
    const navigate = useNavigate()

    const closeUserDataEdit = () => {
        setOpenUserDataEdit(false)
    }

    const handleRefreshPermissions = async () => {
        setRefreshing(true)
        const ok = await refreshSessionToken()
        setRefreshing(false)
        if (ok) {
            alert('Permisos y token de sesión regenerados exitosamente. Tus datos locales e historial de pautas se mantienen intactos.')
        } else {
            alert('No se pudo refrescar los permisos. Asegúrate de tener conexión a internet.')
        }
    }

    console.log('UserProfilePage userData:', userData)

    return (
        <Box height='100%'>
            {openUserDataEdit && <UserDataEditDialog
                open={openUserDataEdit}
                handleClose={closeUserDataEdit}
                userData={userData}
            />}
            <Grid className={'root'} container spacing={0}>
                <Grid className={'pageContainer'} item xs={12}>
                    <Card elevation={0} className={'pageCard'}>
                        <Grid container>
                            <div style={{ width: '100%', textAlign: 'left', padding: 10 }}>
                                <div style={{ width: '100%', textAlign: 'left', color: '#333', backgroundColor: '#fff', borderRadius: 20 }}>
                                    <Toolbar style={{ paddingLeft: 0, backgroundColor: '#F9F9F9', borderRadius: 10 }}>
                                        <IconButton onClick={() => navigate(-1)}>
                                            <ArrowBackIos style={{ color: '#333', fontSize: 16 }}/>
                                        </IconButton>
                                        <h1 style={{ marginTop: 0, marginBottom: 0, fontSize: 16 }}>
                                            Mi Perfil
                                        </h1>
                                    </Toolbar>
                                </div>
                            </div>
                        </Grid>
                        <Grid container justifyContent='center' style={{ overflowY: 'auto', padding: '20px', height: 'calc(100vh - 150px)' }}>
                            {userData ? (
                                <Grid container spacing={4} item xs={12} md={10} lg={8}>
                                    {/* User Info Section */}
                                    <Grid item xs={12} md={6}>
                                        <Card variant="outlined" style={{ padding: '24px' }}>
                                            <h3 style={{ marginTop: 0, marginBottom: '20px' }}>Mis Datos</h3>
                                            <p style={{ margin: '12px 0' }}><strong>Nombre:</strong> {userData.name} {userData.lastName}</p>
                                            <p style={{ margin: '12px 0' }}><strong>RUT:</strong> {userData.rut}</p>
                                            <p style={{ margin: '12px 0' }}><strong>Email:</strong> {userData.email}</p>
                                            <p style={{ margin: '12px 0' }}><strong>Teléfono:</strong> {userData.phone || 'No ingresado'}</p>
                                            <p style={{ margin: '12px 0' }}><strong>Rol:</strong> {userData.role?.name || 'N/A'}</p>
                                            <div style={{ marginTop: '30px', display: 'flex', gap: '10px' }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    fullWidth
                                                    onClick={() => setOpenUserDataEdit(true)}
                                                >
                                                    Editar Mis Datos
                                                </Button>
                                                <Button
                                                    variant="outlined"
                                                    color="secondary"
                                                    fullWidth
                                                    disabled={refreshing}
                                                    onClick={handleRefreshPermissions}
                                                >
                                                    {refreshing ? 'Refrescando...' : 'Refrescar Permisos'}
                                                </Button>
                                            </div>
                                        </Card>
                                    </Grid>

                                    {/* Signature Section */}
                                    <Grid item xs={12} md={6}>
                                        <Card variant="outlined" style={{ padding: '24px' }}>
                                            <h3 style={{ marginTop: 0, marginBottom: '20px' }}>Mi Firma</h3>
                                            {userData && userData.sign ? (
                                                <div style={{ 
                                                    textAlign: 'center', 
                                                    backgroundColor: '#fff', 
                                                    border: '1px solid #ddd', 
                                                    borderRadius: '8px', 
                                                    padding: '10px', 
                                                    height: '168px', 
                                                    display: 'flex', 
                                                    alignItems: 'center', 
                                                    justifyContent: 'center',
                                                    marginTop: '15px'
                                                }}>
                                                    <img 
                                                        src={userData.sign.startsWith('data:') ? userData.sign : `data:image/png;base64,${userData.sign}`} 
                                                        alt="Firma del usuario" 
                                                        style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} 
                                                    />
                                                </div>
                                            ) : (
                                                <p style={{ fontStyle: 'italic', color: '#777', margin: '40px 0', textAlign: 'center' }}>
                                                    No se ha registrado ninguna firma todavía.
                                                </p>
                                            )}
                                            <div style={{ marginTop: '30px' }}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    fullWidth
                                                    onClick={() => setOpenSign(true)}
                                                >
                                                    {userData && userData.sign ? 'Editar Firma' : 'Dibujar Firma'}
                                                </Button>
                                            </div>
                                        </Card>
                                    </Grid>
                                </Grid>
                            ) : (
                                <p>Cargando datos del usuario...</p>
                            )}
                        </Grid>
                    </Card>
                </Grid>
            </Grid>
        </Box>
    )
}

export default UserProfilePage
